import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { DashboardConstants } from '../../actions/constant';
import dashboardServices from 'src/services/apiServices/dashboard-services/dashboard-services';
import { logoutUser } from 'src/routes/AuthContext';
const {
  POST_DASHBOARD_CHECKOUT_REQUEST,
  POST_DASHBOARD_CHECKOUT_SUCCESS,
  POST_DASHBOARD_CHECKOUT_FAILURE,
  POST_DASHBOARD_CHECKOUT_LOADER,
} = DashboardConstants;

function* dashboardTimeCheckOut(action: any): SagaReturnType<any> {
  try {
    yield put({ type: POST_DASHBOARD_CHECKOUT_LOADER });
    const response = yield call(dashboardServices.postTimeCheckout, action.payload);
    if (response?.status === 200) {
      if (action?.payload?.idleTimeExpired) {
        logoutUser();
      }
      yield put({
        type: POST_DASHBOARD_CHECKOUT_SUCCESS,
        payload: response.data,
        action:
          action?.payload?.timer === 'CLOCK_IN'
            ? 'CLOCK_IN_SUCCESS'
            : action?.payload?.timer === 'CLOCK_OUT'
            ? 'CLOCK_OUT_SUCCESS'
            : null,
        isLogout: action?.payload?.isLogout,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    if (action?.payload?.idleTimeExpired) {
      logoutUser();
    }
    yield put({
      type: POST_DASHBOARD_CHECKOUT_FAILURE,
      payload: error,
      isLogout: action?.payload?.isLogout,
    });
  }
}

function* dashboardTimeCheckOutSaga() {
  yield takeEvery(POST_DASHBOARD_CHECKOUT_REQUEST, dashboardTimeCheckOut);
}

export default dashboardTimeCheckOutSaga;
